import { React, PropTypes, FelaComponent, Icon, Tooltip, noop } from '../dependencies';

import { iconRule, disabledRule, favouriteButtonRule, tooltipTextRule } from './restaurantActionsRules';

const texts = {
    link: <FelaComponent rule={tooltipTextRule}>Otevřít webovou stránku restaurace.</FelaComponent>,
    train: (
        <FelaComponent rule={tooltipTextRule}>
            Spustit Lunch train.
            <br />
            MOMENTÁLNĚ NEPODPOROVÁNO!.
        </FelaComponent>
    ),
    favourite: <FelaComponent rule={tooltipTextRule}>Označit restauraci jako oblíbenou.</FelaComponent>,
};

export const RestaurantLink = ({ url }) => (
    <FelaComponent
        rule={iconRule}
        render={({ className }) => (
            <Tooltip placement="bottom" title={texts.link}>
                <a href={url} className={className} target="_blank" rel="noopener noreferrer">
                    <Icon type="home" />
                </a>
            </Tooltip>
        )}
    />
);

RestaurantLink.propTypes = {
    url: PropTypes.string.isRequired,
};

export const StartTrain = () => (
    <FelaComponent
        rule={disabledRule}
        render={({ className }) => (
            <Tooltip placement="bottom" title={texts.train}>
                <span className={className} role="button" tabIndex="-1">
                    <Icon type="car" />
                </span>
            </Tooltip>
        )}
    />
);

export const Favourite = ({ favourite, onToggle }) => (
    <FelaComponent
        rule={favouriteButtonRule}
        favourite={favourite}
        render={({ className }) => (
            <Tooltip placement="bottom" title={texts.favourite}>
                <a className={className} role="button" tabIndex="-1" onClick={onToggle}>
                    <Icon theme={favourite ? 'filled' : 'outlined'} type="star" />
                </a>
            </Tooltip>
        )}
    />
);

Favourite.propTypes = {
    favourite: PropTypes.bool,
    onToggle: PropTypes.func,
};

Favourite.defaultProps = {
    favourite: false,
    onToggle: noop,
};
